import { Portal as MuiPortal } from '@mui/material';
import { EmbedShadowRoot } from './embed-shadow-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export var ShadowPortal = function ShadowPortal(_ref) {
  var children = _ref.children,
      mountNode = _ref.mountNode;
  return /*#__PURE__*/_jsx(MuiPortal, {
    container: mountNode,
    "data-element": "MuiPortal",
    "data-component": "ShadowPortal",
    "data-source-file": "shadow-portal.tsx",
    children: /*#__PURE__*/_jsx(EmbedShadowRoot, {
      "data-element": "EmbedShadowRoot",
      "data-component": "ShadowPortal",
      "data-source-file": "shadow-portal.tsx",
      children: children
    })
  });
};